module.exports = __webpack_public_path__ + "35f80cde5b3f61e8044b7ce46a59fc15.mp3";